import React from 'react';
import {connect} from "react-redux";
import style from './PropertiesOnMap.module.scss';
import * as propertyActions from "../../../../redux/action/property.action";
import MyMapComponent from "../PropertiesOnClusterMap/PropertiesOnClusterMap.component";

class PropertiesOnMap extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      properties: [],
      lat: '35.711555',
      long: '51.394987'
    }
  }

  componentDidMount() {
    this.fetchPropertiesLocations();
  }

  async fetchPropertiesLocations() {
    const { fetchPropertiesLocation } = this.props;
    const { lat, long } = this.state;
    const properties = await fetchPropertiesLocation(long, lat);
    this.setState({ properties })
  }

  render() {
    const {lat, long, properties} = this.state;
    return (
        <div className={style.map_container}>
          {
            !!properties && !!properties.length && (
              <MyMapComponent
                centerCoordinator={[long, lat]}
                data={properties} />
            )
          }
        </div>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
  fetchPropertiesLocation: (lat, long) => dispatch(propertyActions.fetchPropertiesLocation(lat, long)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PropertiesOnMap);
